// global
export const g = {
	EVENT: 'EVENT',
	INCENTIVE: 'INCENTIVE',
	PARTS: 'PARTS',
	SERVICE: 'SERVICE',
	VEHICLE: 'VEHICLE'
};

// actions
export const a = {
	SET_ACCOUNT: 'SET_ACCOUNT',
	SET_INCENTIVES: 'SET_INCENTIVES',
	SET_PERSONALIZED: 'SET_PERSONALIZED',
	SET_TEST_PARAMS: 'SET_TEST_PARAMS',
	SET_HAS_DATA: 'SET_HAS_DATA'
};

// actions
export const aR = {
	DESKTOP_10X1: 'Desktop10x1',
	DESKTOP_4X1: 'Desktop4x1',
	DESKTOP_4X3: 'Desktop4x3',
	MOBILE_4X3: 'Mobile4x3',
	MOBILE_4X3_SLIDESHOW: 'Mobile4x3_slideshow',
	MOBILE_4X3_COUPON: 'Mobile4x3_coupon',
	MOBILE_6X1: 'Mobile6x1'
};

// The aspect ratios correspond to our old "placements"
export const aspectRatios = new Map([
	['Desktop10x1', 'banner'],
	['Desktop4x1', 'slideshow'],
	['Desktop4x3', 'listing'],
	['Mobile4x3_slideshow', 'slideshow'],
	['Mobile4x3_coupon', 'listing'],
	['Mobile6x1', 'banner']
]);

export const aspectRatiosProportions = new Map([
	['Desktop10x1', [10, 1]],
	['Desktop4x1', [4, 1]],
	['Desktop4x3', [4, 3]],
	['Mobile4x3_slideshow', [4, 3]],
	['Mobile4x3_coupon', [4, 3]],
	['Mobile6x1', [6, 1]]
]);

export const perpetualOptions = {
	NO_SHOW: 'NO_SHOW',
	NO_SHOW_ON_SPECIAL: 'NO_SHOW_ON_SPECIAL'
};

export const LEAD_FORM_URL = '/promotions/lead-form.htm?promotionId=';
